export const getAbbreviationIndex = (email?: string, emails?: string[]) => {
  if (!email || !emails || emails.length === 0) {
    return 0;
  }

  const getParts = (e: string) => e.split("@")[0].split(".");
  const targetParts = getParts(email);
  const targetFirstName = (targetParts[0] || "").toLowerCase();

  // others with same first name, excluding the target itself
  const othersWithSameFirstName = emails
    .filter((e) => e !== email)
    .map(getParts)
    .filter((p) => (p[0] || "").toLowerCase() === targetFirstName);

  // no one shares first name -> 0
  if (othersWithSameFirstName.length === 0) {
    return 0;
  }

  const targetSurname = targetParts.slice(1).join(" ").trim().toLowerCase();
  if (!targetSurname) {
    return 0;
  }

  const othersSurnames = othersWithSameFirstName
    .map((p) => p.slice(1).join(" ").toLowerCase())
    .filter((s) => s.length > 0);

  for (let x = 1; x <= targetSurname.length; x++) {
    const prefix = targetSurname.slice(0, x);
    const conflicts = othersSurnames.filter((s) => s.startsWith(prefix));
    // return last index included (0-based)
    if (conflicts.length === 0) {
      return x - 1;
    }
  }

  // If full surname still conflicts, return last char index
  return targetSurname.length - 1;
};
